import { trackEventAndOmitTypeName } from './trackEventAndOmitTypeName';

export interface ShowMoreTilesData {
  schema: string;
  data: {
    event_name: string;
    user_action: string;
    in_page_source: string;
  };
}

export const trackShowMoreTiles = (eventData: ShowMoreTilesData): void => {
  trackEventAndOmitTypeName(eventData);
};
